export const FINANCE_DISCOVERY_EVENTS = {
  ELIGIBILITY_RESOLVED: 'finance_discovery_eligibility_resolved',
  // Fired on /payment for BOTH arms, BEFORE the paywall. The ITT denominator for the pre-paywall
  // conversion read — ELIGIBILITY_RESOLVED fires at checkout success, which is after this moment.
  PREPAYWALL_ELIGIBILITY_RESOLVED: 'finance_discovery_prepaywall_eligibility_resolved',
  ENTERED: 'finance_discovery_entered',
  // THE PRE-PAYWALL HAND-OFF, the conversion mechanic. An unpaid learner who finishes the sprint meets
  // a modal that names the artifact they just made and asks for the trial. HANDOFF_SHOWN is the
  // denominator for that ask; TRIAL_CLICKED over SHOWN is the conversion rate this experiment exists to
  // move. A subscribed learner never fires any of the three.
  HANDOFF_SHOWN: 'finance_discovery_handoff_shown',
  HANDOFF_TRIAL_CLICKED: 'finance_discovery_handoff_trial_clicked',
  HANDOFF_DISMISSED: 'finance_discovery_handoff_dismissed',
  // Per-step progress — emitted the FIRST time each of the 18 steps is reached. Powers the
  // abandon-point funnel (the furthest stepIndex a user reaches = their completion %), which is the
  // #1 success metric (median completion rate for users who abandon the flow).
  STEP_VIEWED: 'finance_discovery_step_viewed',
  MODULE_COMPLETED: 'finance_discovery_module_completed',
  ARCHETYPE_REVEALED: 'finance_discovery_archetype_revealed',
  FLOW_COMPLETED: 'finance_discovery_flow_completed',
  RECOMMENDATION_CLICKED: 'finance_discovery_recommendation_clicked',
  OFFER_SHOWN: 'finance_discovery_offer_shown',
  OFFER_STARTED: 'finance_discovery_offer_started',
  OFFER_DISMISSED: 'finance_discovery_offer_dismissed',
  // THE IN-SPRINT TRIAL BAR — pinned to the bottom of every sprint screen for unpaid learners.
  // Asks for the trial DURING the work, where HANDOFF_* asks after it. Kept as its own pair so
  // the two moments can be compared instead of blended.
  TRIAL_BAR_SHOWN: 'finance_discovery_trial_bar_shown',
  TRIAL_BAR_CLICKED: 'finance_discovery_trial_bar_clicked',
} as const;

export type FinanceDiscoveryEventName = (typeof FINANCE_DISCOVERY_EVENTS)[keyof typeof FINANCE_DISCOVERY_EVENTS];
